module.exports = __webpack_public_path__ + "img/handsigns.690d0e7b.jpg";